import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LockKey } from "@phosphor-icons/react";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const token = sp.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Minimo 6 caratteri"); return; }
    if (password !== confirm) { toast.error("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata! Ora puoi accedere.");
      navigate("/login");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore, link non valido o scaduto");
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4">
        <div className="text-center">
          <p className="text-muted-foreground">Link non valido.</p>
          <Link to="/forgot-password" className="text-primary font-medium">Richiedi un nuovo link</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4 py-10">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-card border border-border rounded-2xl p-7 shadow-sm">
        <span className="grid place-items-center w-11 h-11 rounded-xl bg-accent text-accent-foreground mb-4">
          <LockKey size={22} weight="duotone" />
        </span>
        <h1 className="font-heading text-2xl font-bold">Nuova password</h1>
        <p className="text-muted-foreground text-sm mt-1">Scegli una nuova password per il tuo account.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="pw">Nuova password</Label>
            <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="cf">Conferma password</Label>
            <Input id="cf" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm" className="mt-1.5" />
          </div>
          <Button type="submit" className="w-full rounded-full" disabled={loading} data-testid="reset-submit">
            {loading ? "Aggiornamento…" : "Aggiorna password"}
          </Button>
        </form>
      </motion.div>
    </div>
  );
};

export default ResetPassword;
